<template>
  <b-card :title="cardTitle">
    <template slot="body">
      <div class="card-body p-0">

          <b-tabs
            nav-id="timeseries-card-tabs"
            tabs-id="timeseries-card-tabs-content"
            :data-loading="dataLoading">

            <b-tab label="Chart" id="data-tab-chart">
              <timeseries-chart ref="chart" :chart-data="displayedData"></timeseries-chart>
              
              <div v-if="displayedData">

                  <div v-for="(data, idx) in displayedData">
                      <label v-if="data.meta.aggregate"> {{data.meta.aggregate.name}} : {{data.meta.aggregate.value | toFixedLocaleString}} </label>
                  </div>
                  
              </div>
              
                <button class="btn btn-sm btn-primary border border-dark float-right" @click="$refs.chart.exportToImg()" >PNG</button>

            </b-tab>

            <b-tab label="Table" id="data-tab-table">

              <timeseries-table ref="table" :table-data="displayedData"></timeseries-table>
              <button class="btn btn-sm btn-primary border border-dark float-right" @click="$refs.table.exportTableToCSV()" > CSV </button>

            </b-tab>

          </b-tabs>

          <div class="query-controls pl-3 pr-3 pb-3">
            <slot :query-params="queryParams">
            </slot>
            <button @click="onGetData" class="btn btn-primary border border-dark"> Get Data </button>
          </div>

      </div>
    </template>
  </b-card>
</template>

<script>
import BTabs from '../common/BootstrapTabs';
import BTab from '../common/BootstrapTab';
import TimeseriesChart from './TimeseriesChartComponent';
import TimeseriesTable from './TimeseriesTableComponent';
import ChartCard from '../mixins/ChartCardMixin';
import Filters from '../mixins/Filters';

export default {
    components: {
        'timeseries-chart': TimeseriesChart,
        'timeseries-table': TimeseriesTable,
        'b-tabs': BTabs,
        'b-tab': BTab,
    },

    mixins: [ChartCard, Filters],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/TimeseriesCardComponent.vue